// extracted by mini-css-extract-plugin
module.exports = {"itemsList":"Select_itemsList__A6LA7","invalidText":"Select_invalidText__2D8uV"};